import { Label } from '@components/label/src/label';
import classNames from 'classnames';

import { LabelSecondaryProps } from './label.types';

export const LabelSecondary = ({ children, hasError = false, className, ...props }: LabelSecondaryProps) => {
  return (
    <Label
      {...props}
      className={classNames(
        {
          'text-critical': hasError,
          'text-primary': !hasError,
        },
        'text-body-s',
        className
      )}>
      {children}
    </Label>
  );
};
